@if ({ allClientData: clientData$() | async }; as $) {
  <p-dialog
    [visible]="assignFitpassModal()"
    [resizable]="false"
    appendTo="body"
    [modal]="true"
    [closeOnEscape]="true"
    (onHide)="closeDialogEvent()"
    [breakpoints]="{ '991px': '100vw' }"
    [style]="{ width: '700px' }"
    styleClass="no-header-modal"
  >
    <ng-template pTemplate="header" styleClass="hidden" />
    <ng-template pTemplate="content" styleClass="p-0">
      <div
        class="p-3 flex align-items-center justify-content-between border-bottom-1 border-300"
      >
        @if (allClientData) {
          <div class="flex align-items-center">
            <h2 class="mb-0 text-sm">
              {{ 'CLIENT_PROFILE.FITPASS.ASSIGN_FITPASS_FOR' | translate }}
              <strong>{{ $.allClientData.full_name }} </strong>
              <span class="text-xs text-600"> - {{ $.allClientData.id }}</span>
            </h2>
          </div>
        }
        <button
          type="button"
          class="fa fa-times text-xl text-600 cursor-pointer border-none bg-transparent p-0"
          (click)="closeDialogEvent()"
          aria-label="close-assign-fitpass-dialog"
        ></button>
      </div>

      <div class="flex">
        <div
          class="border-right-1 border-300 lg:w-8 w-full surface-100 flex flex-column justify-content-between"
        >
          <form
            [formGroup]="assignFitpassFormGroup"
            (ngSubmit)="postAssignFitpass()"
          >
            <div class="py-3 md:py-5 px-3 md:px-5">
              @if ($.allClientData && fitpassMapping?.provider_id) {
                <div class="mb-4 text-sm">
                  <label
                    class="font-medium text-700 text-xs mb-2 block uppercase"
                    >{{
                      'CLIENT_PROFILE.FITPASS.CURRENT_FITPASS_ID' | translate
                    }}</label
                  >
                  <strong class="text-sm">{{
                    fitpassMapping?.provider_id
                  }}</strong>
                </div>
              }
              <label class="font-medium text-700 text-xs mb-2 block uppercase">
                @if (!fitpassMapping?.provider_id) {
                  <span>{{
                    'CLIENT_PROFILE.FITPASS.ENTER_FITPASS_ID' | translate
                  }}</span>
                }
                @if (fitpassMapping?.provider_id) {
                  <span>{{
                    'CLIENT_PROFILE.FITPASS.CHANGE_FITPASS_ID' | translate
                  }}</span>
                }
              </label>
              <input
                type="text"
                class="w-full text-sm"
                pInputText
                formControlName="fitpassId"
                aria-label="fitpass-id-input"
              />
              @if (fitpassId.dirty && fitpassId.invalid) {
                <app-error-msg
                  [errors]="fitpassId.errors"
                  [fieldLabel]="'CLIENT_PROFILE.FITPASS.FITPASS_ID' | translate"
                />
              }
            </div>

            <div class="lg:px-4 px-2 py-3 border-top-1 border-400 surface-0">
              <div class="flex align-items-center justify-content-between">
                <div class="w-4">
                  @if (fitpassMapping?.provider_id) {
                    <p-button
                      type="button"
                      [label]="'CLIENT_PROFILE.FITPASS.DELETE' | translate"
                      icon="pi pi-trash"
                      styleClass="p-button-danger text-sm"
                      (click)="deleteFitpass()"
                      [loading]="btnLoading"
                      aria-label="delete-fitpass-button"
                    />
                  }
                </div>
                <div
                  class="w-8 text-right flex align-items-center justify-content-end gap-2"
                >
                  <p-button
                    type="button"
                    [label]="'CLIENT_PROFILE.FITPASS.CANCEL' | translate"
                    styleClass="p-button-link text-sm"
                    (click)="closeDialogEvent()"
                    aria-label="cancel-fitpass-button"
                  />
                  <button
                    type="submit"
                    class="text-sm"
                    pButton
                    pRipple
                    [loading]="btnLoading"
                    [disabled]="!canSubmitForm"
                    [label]="'CLIENT_PROFILE.FITPASS.ASSIGN' | translate"
                    aria-label="assign-fitpass-submit-button"
                  ></button>
                </div>
              </div>
            </div>
          </form>
        </div>

        <div
          class="pl-3 w-4 hidden lg:flex align-items-center justify-content-center p-3 text-right"
        >
          <img
            width="160"
            src="/assets/img/assign-keyFOB-img.svg"
            alt="Assign FitPass"
          />
        </div>
      </div>
    </ng-template>
  </p-dialog>
}
